import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { fetchVenues } from "../APIs/Venue/GetVenues";
import { useLoadingStatus } from "../context/LoadingStatusContext";

export const useGetVenues = (venueGroupId: string | undefined) => {
  const { updateStage } = useLoadingStatus();
  const fiveMinutes = 5 * 60 * 1000;

  const { data, refetch, isLoading, isError, error } = useQuery({
    queryKey: ["venues", venueGroupId],
    queryFn: () => fetchVenues(venueGroupId),
    retry: 3,
    retryDelay: 3000,
    gcTime: fiveMinutes,
    enabled: !!venueGroupId
  });

  useEffect(() => {
    if (!venueGroupId) {
      return;
    }

    if (isLoading) {
      updateStage("venues", "loading");
    } else if (isError) {
      updateStage("venues", "error", {
        message: "Failed to fetch venue list. Please try again.",
        technicalDetails: error instanceof Error ? error.message : String(error)
      });
    } else if (data !== undefined) {
      if (data.length === 0) {
        updateStage("venues", "error", {
          message: "No venues found for this organisation.",
          technicalDetails: `fetchVenues() returned empty array for venueGroupId: ${venueGroupId}`
        });
      } else {
        updateStage("venues", "success");
      }
    }
  }, [venueGroupId, isLoading, isError, data, error, updateStage]);

  return {
    allVenues: data,
    refetchVenues: refetch,
    areVenuesLoading: isLoading,
    hasVenuesError: isError,
    venuesError: error
  };
};
